import React, { useContext, useEffect } from 'react'
import { CButton, CModal, CModalBody, CModalFooter, CModalHeader } from '@coreui/react'
import useAxios from 'axios-hooks'
import { ACTIVATE_USER_ACCOUNT, DEACTIVATE_USER_ACCOUNT } from '../../../utils/urls'
import { AppContext } from '../../../context/app'
import { raiseToast } from '../../../utils/helper'

const ActivateDeactivateUser = (props) => {
  const { user, showModal, handleClose, successCallback } = props
  const { setLoader } = useContext(AppContext)

  const [{ data: activateUserData, loading: activateUserLoading }, activateUserCall] = useAxios(
    {
      url: `${ACTIVATE_USER_ACCOUNT}`,
      method: 'put',
    },
    { manual: true },
  )

  const [{ data: deActivateUserData, loading: deActivateUserLoading }, deActivateUserCall] =
    useAxios(
      {
        url: `${DEACTIVATE_USER_ACCOUNT}`,
        method: 'put',
      },
      { manual: true },
    )

  useEffect(() => {
    setLoader(deActivateUserLoading || activateUserLoading)
  }, [activateUserLoading, deActivateUserLoading])

  const handleActivateDeactivate = () => {
    if (!user.status) {
      activateUserCall({
        data: { user_id: user._id },
      })
    } else {
      deActivateUserCall({
        data: { user_id: user._id },
      })
    }
  }

  useEffect(() => {
    if (activateUserData && activateUserData.success) {
      raiseToast('success', 'Account activated successfully')
      successCallback()
      handleClose()
    }
  }, [activateUserData])

  useEffect(() => {
    if (deActivateUserData && deActivateUserData.success) {
      raiseToast('success', 'Account deactivated successfully')
      successCallback()
      handleClose()
    }
  }, [deActivateUserData])

  return (
    <>
      <CModal size="md" visible={showModal} alignment="center" onClose={handleClose}>
        <CModalHeader closeButton>
          {user.status ? 'Deactivate' : 'Activate'} {user.name}
        </CModalHeader>
        {user.status && (
          <CModalBody>
            After deactivation user will not able to login.
            <br /> Do you want to deactivate?
          </CModalBody>
        )}
        {!user.status && <CModalBody>Do you want to activate the user?</CModalBody>}
        <CModalFooter>
          <CButton color="primary" onClick={handleActivateDeactivate}>
            {user.status ? 'Deactivate' : 'Activate'}
          </CButton>{' '}
          <CButton color="secondary" onClick={handleClose}>
            Cancel
          </CButton>
        </CModalFooter>
      </CModal>
    </>
  )
}

export default ActivateDeactivateUser
